import { render, staticRenderFns } from "./SalesInvoices.vue?vue&type=template&id=a6dc1b14&scoped=true"
import script from "./SalesInvoices.vue?vue&type=script&lang=ts"
export * from "./SalesInvoices.vue?vue&type=script&lang=ts"
import style0 from "./SalesInvoices.vue?vue&type=style&index=0&id=a6dc1b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6dc1b14",
  null
  
)

export default component.exports